<script>
    import { Indicator, Modal, Tooltip } from "flowbite-svelte";
    import { writable } from "svelte/store";
    import { global_state } from "../../service/store";
    import { getNestedDict } from "../../service/sse";
    import { onMount } from "svelte";
    export let title = "";
    export let component_address;

    let id = `indicator-${crypto.randomUUID()}`;
    let showModal = false;

    let result_judgement = writable(false);
    let result_rationale = writable("Not evaluated yet");

    onMount(() => {
        global_state.subscribe((state) => {
            const value = getNestedDict(state, [
                ...component_address,
                "data",
                "content",
            ]);

            if (value) {
                const parsed_value = (value);

                result_judgement.set( parsed_value?.result_judgement ?? false);
                result_rationale.set(parsed_value?.result_rationale ?? "");
            }

            // if (value?.toLowerCase().includes("yes")) {
            //     yes_or_no.set(true);
            // } else if (value?.toLowerCase().includes("no")) {
            //     yes_or_no.set(false);
            // } else {
            //     yes_or_no.set(undefined);
            // }
        });
    });

    export function regenerate() {}

    function toggleModal() {
        console.log("toggleModal");
        showModal = !showModal;
    }
</script>

<div class="relative">
    <div on:click={toggleModal}>
        <Indicator
            {id}
            rounded
            size="xl"
            color={$result_judgement === true ? "green" : "gray"}
            class="mx-3 cursor-pointer"
        />
    </div>
    <Tooltip trigger="hover" placement="top" triggeredBy="#{id}"
        >{title}</Tooltip
    >
    <Modal bind:open={showModal} {title}>
        <div class="text-base leading-relaxed">
            {$result_rationale || "Not evaluated yet"}
        </div>
    </Modal>
</div>
